import 'src/styles/ui/alert.css';

import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import classNames from 'classnames';
import PropTypes from 'prop-types';
import React from 'react';

/**
 * Customizable Alert Component
 *
 * @param {Object} props
 * @param {'warning' | 'info' | 'danger'} props.variant - Alert style variant
 * @param {React.ReactNode} props.icon - FontAwesome icon component
 * @param {string} props.title - Alert title text
 * @param {React.ReactNode} props.children - Alert content
 * @param {string} props.className - Additional CSS classes
 */
const Alert = ({ variant = 'info', icon, title, children, className, iconClassName, ...props }) => {
  const alertClasses = classNames(
    'alert-custom',
    {
      'alert-custom--warning': variant === 'warning',
      'alert-custom--info': variant === 'info',
      'alert-custom--danger': variant === 'danger',
    },
    className
  );

  return (
    <div className={alertClasses} {...props}>
      {(icon || title) && (
        <div className='alert-custom__title'>
          {icon && <FontAwesomeIcon className={iconClassName} icon={icon} />}
          {title}
        </div>
      )}
      {children && <div className='alert-custom__text'>{children}</div>}
    </div>
  );
};

Alert.propTypes = {
  variant: PropTypes.oneOf(['warning', 'info', 'danger']),
  icon: PropTypes.object,
  title: PropTypes.string,
  children: PropTypes.node,
  className: PropTypes.string,
  iconClassName: PropTypes.string,
};

Alert.defaultProps = {
  variant: 'info',
  icon: null,
  title: '',
  children: null,
  className: '',
  iconClassName: '',
};

export default Alert;
